import {sessionUtil} from "./session";
import {util} from "./utils";

export const Cookies = function () {
  this.getSession = function () {
    return sessionUtil.getSession()
  }
  /**
   * 验证
   */
  this.validToken = function () {
    // 直接返回true,留给后台去验证
    return true;
  }
  this.clearSession = function () {
    sessionUtil.removeSession()
  }
  this.set = function (name, value, expire) {
    var domain = util.getBaseUrl()
    name = domain + '-' + name
    
    var data = { value: value, _expire: expire == undefined ? 7200 : expire, _createTime: new Date() }
    window.localStorage.setItem(name, JSON.stringify(data))
    return null
  }

  this.get = function (name) {
    var domain = util.getBaseUrl()
    name = domain + '-' + name
    var data = window.localStorage.getItem(name)
    
    if (data == null) {
      return null
    }
    try {
      data = JSON.parse(data)
    } catch (e) {
      
      return null
    }
    
    var expire = data._expire
    if (expire != undefined) {
      return data.value
    }
    return data
  }

  this.clear = function (name) {
    var domain = util.getBaseUrl()
    name = domain + '-' + name
    window.localStorage.setItem(name, null)
    window.localStorage.removeItem(name)
  }
  this.clearAll = function () {
    window.localStorage.clear()
  }
}
export const cookieUtil = new Cookies()



// WEBPACK FOOTER //
// ./src/utils/cookie.js